export default {
  methods: {
    external(item) {
      const {
        $router,
      } = this;

      if ($router.resolve(item.url).route.meta.external) {
        return true;
      }

      return true;
    },
  },
};
